import {
  WhoAmIRequest,
  WhoAmIResponse,
  WhoAmIOptions,
  ApiClient,
} from "@quotientjs/core"

export class Auth {
  private apiClient: ApiClient

  constructor(apiClient: ApiClient) {
    this.apiClient = apiClient
  }

  async whoami(options: WhoAmIOptions): Promise<WhoAmIResponse> {
    const request = new WhoAmIRequest(options)
    return this.apiClient.call(request)
  }
}
